import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export async function getDepositSchedule(leadId, callback) {
	firebaseRef
		.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/depositSchedule'
		)
		.once('value', (snapshot) => {
			var depositObj = snapshot.val();

			var depositeArr = [];

			var depositObjKeys = depositObj && Object.keys(depositObj);

			depositObjKeys &&
				depositObjKeys.forEach((key) => {
					var deposit = depositObj[key];

					depositeArr.push(deposit);
				});
			callback(depositeArr);
		});
}
